import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                91安全指南
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于提供网络安全资讯与使用指南，帮助用户识别虚假页面、防范恶意下载和保护个人隐私。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/article/how-to-identify-fake-91-pages"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  如何识别虚假页面
                </Link>
              </li>
              <li>
                <Link
                  to="/article/malware-download-risks"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  恶意下载的常见套路
                </Link>
              </li>
              <li>
                <Link
                  to="/article/privacy-protection-basics"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  网络隐私保护基础
                </Link>
              </li>
              <li>
                <Link
                  to="/article/identify-official-versions"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  官方版本辨别指南
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关于本站
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  联系方式
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  免责声明
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 91安全指南. 本站内容仅供安全学习参考，请遵守当地法律法规。
          </p>
          <p className="text-xs text-background-600">
            访问或下载前请确认来源可靠
          </p>
        </div>
      </div>
    </footer>
  );
}